import { NavLink } from "react-router-dom"
import { LayoutDashboard, Upload, ClipboardCheck, Users, ScrollText, Sparkles, Plane, Key, Headset, BookOpen, Settings } from "lucide-react"
import { cn } from "@/lib/utils"
import { useAuthStore } from "@/stores/auth-store"

interface NavItem {
  to: string
  label: string
  icon: typeof LayoutDashboard
  minRole?: "advisor" | "operator" | "admin"
}

const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", label: "工作台", icon: LayoutDashboard },
  { to: "/upload-center", label: "上传中心", icon: Upload },
  { to: "/knowledge-library", label: "知识库", icon: BookOpen, minRole: "operator" },
  { to: "/vip-handoff", label: "VIP承接", icon: Headset, minRole: "advisor" },
  { to: "/settings/vip-counselor", label: "承接设置", icon: Settings, minRole: "admin" },
  { to: "/review", label: "审核队列", icon: ClipboardCheck, minRole: "operator" },
  { to: "/staff", label: "员工管理", icon: Users, minRole: "admin" },
  { to: "/audit-logs", label: "审计日志", icon: ScrollText, minRole: "admin" },
  { to: "/travel-agencies", label: "旅行社", icon: Plane, minRole: "operator" },
  { to: "/evolution", label: "Evolution", icon: Sparkles, minRole: "admin" },
  { to: "/api-keys", label: "API Keys", icon: Key, minRole: "admin" },
]

const ROLE_RANK = { advisor: 1, operator: 2, admin: 3 } as const

export function Sidebar() {
  const staff = useAuthStore((s) => s.staff)
  const actualRank = staff ? ROLE_RANK[staff.role] : 0

  const visibleItems = NAV_ITEMS.filter((item) => {
    if (!item.minRole) return true
    return actualRank >= ROLE_RANK[item.minRole]
  })

  return (
    <aside className="w-56 border-r border-border bg-secondary/30 p-3">
      <nav className="space-y-1">
        {visibleItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground hover:bg-accent hover:text-accent-foreground",
              )
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
